// src/layout/nav-items.ts
//
// The nav is the app's whole feature index.
//
// The design's discovery rule: nothing lives only in a dropdown. The avatar
// menu is account items only — settings, theme, sign out — and every study
// feature has to be reachable from this bar. If a feature is added and it
// isn't here, it is effectively hidden, so this list is the single place
// that decision gets made.

export interface NavItem {
  label: string;
  to: string;
  /** Extra path prefixes that should light this item up. Mock Tests stays
   *  active on /mock-tests/my-tests and on an attempt, for instance. */
  match?: string[];
  beta?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { label: "Home", to: "/" },
  { label: "Mock Tests", to: "/mock-tests" },
  { label: "Practice", to: "/practice" },
  { label: "Contests", to: "/contests" },
  { label: "Syllabus", to: "/syllabus" },
  { label: "Study", to: "/study", beta: true },
  { label: "Progress", to: "/progress" },
];

/**
 * Whether `pathname` belongs to `item`.
 *
 * Home is exact — every path starts with "/" — and everything else matches
 * on a path-segment boundary so /practice doesn't also light up for a
 * hypothetical /practice-history.
 */
export function isNavItemActive(item: NavItem, pathname: string): boolean {
  const candidates = [item.to, ...(item.match ?? [])];
  return candidates.some((path) => {
    if (path === "/") return pathname === "/";
    return pathname === path || pathname.startsWith(`${path}/`);
  });
}
